export default __webpack_public_path__ + "static/media/logo.7d5e4f98.svg";